export const useParseUrl = url => {
  return url
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/ /g, '-')
    .replace('undefined/', '')
    .replace('//', '/')
}
